import React from 'react';
import { User } from 'lucide-react';
import { shopItems } from '../data/shopItems';
import { isProfileOnline } from '../utils/onlineStatus';

const UserAvatar = ({ profile, size = 40, style = {}, onClick }) => {
  const isOnline = isProfileOnline(profile);
  const equippedBorder = shopItems.find(i => i.id === profile?.equipped?.border);
  const photoURL = profile?.avatarUrl || profile?.photoURL;
  
  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
    width: size,
    height: size,
    cursor: onClick ? 'pointer' : 'default',
    ...style
  };

  const imgContainerStyle = {
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: profile?.color || 'var(--primary-color)',
    ...(equippedBorder?.style || {})
  };

  const imgStyle = {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    objectFit: 'cover',
  };

  const bubbleSize = Math.min(Math.max(12, size * 0.3), 24);
  const offset = size > 80 ? 4 : -1;

  const statusBubbleStyle = {
    position: 'absolute',
    bottom: offset,
    right: offset,
    width: bubbleSize + 'px',
    height: bubbleSize + 'px',
    borderRadius: '50%',
    backgroundColor: isOnline ? '#22c55e' : '#64748b',
    border: '2px solid var(--bg-card)',
    zIndex: 10,
  };

  return (
    <div style={containerStyle} onClick={onClick}>
      <div className={equippedBorder?.className || ''} style={imgContainerStyle}>
        {photoURL ? (
          <img loading="lazy" src={photoURL} alt={profile?.name || 'Utilisateur'} style={imgStyle} />
        ) : (
          <User size={size * 0.6} color="#fff" />
        )}
      </div>
      
      <div style={statusBubbleStyle} title={isOnline ? "En ligne" : "Hors ligne"} />
    </div>
  );
};

export default UserAvatar;
